<template>
	<el-drawer size="800px" title="高级设置" :modal-append-to-body="false" :visible.sync="dialogVisible" :wrapperClosable="false"
		class="customer-drawer-common">
		<el-tabs type="card" v-model="active">
			<el-tab-pane v-for="(item,index) in tabs" :label="item.name" :name="item.name" :key="index">
				<component :is="item.component" :key="index" :row_item="rows.data" v-if="active == item.name"></component>
			</el-tab-pane>
		</el-tabs>
	</el-drawer>

</template>

<script>
	import setHasKeywords from './setHasKeywords'
	import setNoKeywords from './setNoKeywords'
	import setEvents from './setEvents.vue'
	export default {
		components:{
			setHasKeywords,
			setNoKeywords,
			setEvents
		},
		data() {
			return {
				active: '关键词回复',
				tabs: [{
					name: '关键词回复',
					component:'setHasKeywords'
				}, {
					name: '收到消息回复',
					component:'setNoKeywords'
				},{
					name:'事件配置',
					component:'setEvents'
				}],
				dialogVisible: false,
				rows:{
					data:''
				}
			}
		},
		provide(){
				return {
					 row_data:this.rows
				}
			},
		methods: {
			openSetKeywords(row) {
				this.active = '关键词回复'
				this.dialogVisible = true;
				this.rows.data = row
			}
		}
	}
</script>
<style lang="scss">
	.ser-advanced {
		.el-tabs__content {
			padding: 20px 0;
		}
	}
</style>